module.exports = __webpack_public_path__ + "img/copy-link.f8d57535.png";